import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import PageTitle from '../components/PageTitle';
import '../components/Layout/layout.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Hero from '../components/Hero';
import Layout from '../components/Layout';
import Link from '../components/Link';
import SidebarMenu from '../components/Layout/Navigation/SidebarMenu';

const TwoColumnList = () => {
  const items = [
    // "A. General Information",
    // "B. Enrollment and Persistence",
    // "C. First-Time, First-Year Admission",
    // "D. Transfer Admission",
    // "E. Academic Offerings and Policies",
    // "F. Student Life",
    // "G. Annual Expenses",
    // "H. Financial Aid",
    // "I. Instructional Faculty and Class Size",
    // "J. Degrees Conferred"
  ];

  const midpoint = Math.ceil(items.length / 2);
  const leftColumn = items.slice(0, midpoint);
  const rightColumn = items.slice(midpoint);

  return (
    <div className="row">
      <div className="col-md-6">
        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
          {leftColumn.map((item, index) => (
            <li key={`left-${index}`}>{item}</li>
          ))}
        </ul>
      </div>
      <div className="col-md-6">
        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
          {rightColumn.map((item, index) => (
            <li key={`right-${index}`}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const ExpandableSection = ({ isExpanded, children }) => {
  const contentRef = useRef(null);
  const [height, setHeight] = useState('0px');

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isExpanded ? `${contentRef.current.scrollHeight}px` : '0px');
    }
  }, [isExpanded]);

  return (
    <div
      style={{
        overflow: 'hidden',
        transition: 'max-height 0.5s ease',
        maxHeight: height,
        backgroundColor: '#f8f9fa',
        border: isExpanded ? '1px solid #ddd' : 'none',
        borderTop: 'none',
        borderRadius: isExpanded ? '0 0 4px 4px' : '0',
        marginBottom: isExpanded ? '20px' : '0',
        padding: isExpanded ? '15px 20px' : '0 20px'
      }}
    >
      <div ref={contentRef}>
        {children}
      </div>
    </div>
  );
};


const UniversityRecreation = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => setIsExpanded(prev => !prev);


  return (
    <Layout upper={<Hero />}>
      <div className="row">
        <div className="col-sm-4 col-lg-3 my-4">
          <SidebarMenu />
        </div>

        <div className="col-sm-8 col-lg-9">
          <PageTitle name="University Recreation Center" site="OIRA" />
          <div>
            <p>
              The following reports were developed at the request of the University Recreation Center.
            </p>
            <hr />
            <p>
                A report highlighting the student employees within the Rec Center workforce.
            </p>
            <p>
                <a href="https://app.powerbi.com/view?r=eyJrIjoiZmNjYWIzZmYtMTQ1Ni00ZDA4LTkxNjQtYTAzNDM1ZWRiZTdjIiwidCI6IjJhMDA3MjhlLWYwZDAtNDBiNC1hNGU4LWNlNDMzZjNmYmNhNyIsImMiOjN9" target="_blank" rel="noopener noreferrer">Recreation Center Student Employee Demographics Report</a> (Power BI)
            </p>
            <hr />
            {/* imported from above */}
            <p>
                A report illustratating the use of Rec Center facilities by student.
            </p>
            <p>
                <a href="https://app.powerbi.com/view?r=eyJrIjoiOGQ5MGY0YjUtMDBhYi00ZDZlLThlNTgtNTQyMjgwYzFhNGM1IiwidCI6IjJhMDA3MjhlLWYwZDAtNDBiNC1hNGU4LWNlNDMzZjNmYmNhNyIsImMiOjN9" target="_blank" rel="noopener noreferrer">Recreation Center Utilization Report</a> (Power BI)
            </p>
            {/* <TwoColumnList /> */}

            {/* <p>Click the red bar to show UA's Advising Survey reports.</p> */}

            {/* <div
                onClick={toggleExpanded}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#990000',
                    color: 'white',
                    padding: '10px 20px',
                    width: '100%',
                    marginTop: '20px',
                    cursor: 'pointer',
                    userSelect: 'none',
                    fontSize: '1.5em',
                    fontWeight: 'bold'
                }}
                >
                <span>Advising Survey Reports</span>
                <span>{isExpanded ? '−' : '+'}</span>
            </div>
            <ExpandableSection isExpanded={isExpanded}>
                <p>The following reports are available in HTML format.</p>
                <ul>
                    {[
                    {
                        year: "2025",
                        url: "https://reports.oira-ua.tech/r/advising-survey/report/202510",
                    },
                    {
                        year: "2024",
                        url: "https://reports.oira-ua.tech/r/advising-survey/report/202410",
                    },
                    {
                        year: "2023",
                        url: "https://reports.oira-ua.tech/r/advising-survey/report/202310",
                    },
                    {
                        year: "2022",
                        url: "https://reports.oira-ua.tech/r/advising-survey/report/202210",
                    },
                    {
                        year: "2021",
                        url: "https://reports.oira-ua.tech/r/advising-survey/report/202110",
                    },
                    ].map((report, index) => (
                    <li key={index}>
                        <a href={report.url} target="_blank" rel="noopener noreferrer">
                        Spring {report.year}
                        </a>
                    </li>
                    ))}
                </ul>
                <p>&nbsp;</p>
            </ExpandableSection> */}
          </div>
        </div>
      </div>
    </Layout>
  );
};

const HoverLink = styled(Link)`
  display: inline-block;
  padding: 10px;
  background-color: #ffffff;
  color: #990000;
  text-decoration: none;
  border-radius: 5px;
  border: 2px solid #990000;
  text-align: center;
  font-family: Roboto, Verdana, Helvetica, sans-serif;
  transition: all 0.3s ease;

  &:hover {
    font-weight: bold;
    color: #ffffff;
    background-color: #990000;
  }
`;

export default UniversityRecreation;
